import { createContext } from 'react';

/**
 * Ouverture de la modale de recherche : le header, le menu latéral et le champ
 * inline de la page listing la déclenchent tous.
 *
 * Le contrat vaut aussi quand le chrome passera à WordPress (décision 2) : le
 * header WP émet `document.dispatchEvent(new CustomEvent('tchip:open-search'))`,
 * que ChromeProvider écoute.
 */
const ChromeContext = createContext({ openSearch: () => {}, closeSearch: () => {} });

export default ChromeContext;
